import apiClient from '../../../utils/clients/axios'

export const
    MaterialReturnable = async (payload) => {
        const response = await apiClient.post(
            '/returnablematerials/',
            payload, {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        )

        return response
    }

export const returnMaterialData = async () => {
    const { data } = await apiClient.get('/returnablematerials/queue/')

    console.log({ data })

    return data
}

export const updateMaterialReturnableStatus = async (id) => {
    console.log({ id })
    const response = await apiClient.patch(`/returnablematerials/out?id=${id}`, {
        'status': 'out'
    })

    return response;
}